import "./App.css";
import Body from "./component/body";
import Footer from "./component/footer";
import Header from "./component/header";

function App() {
  return (
    <div className="w-screen h-screen overflow-x-hidden flex justify-center items-center">
      <div className="w-full h-screen fixed text-white z-20 flex justify-center items-center bg-black">
        <img
          src="/images/background.jpg"
          alt="background"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute bg-black/50 w-full h-screen z-30"></div>
      <div className="w-full h-screen flex flex-col z-40">
        <Header />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default App;
